import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var itemListRes;
export const itemListTodo = createAsyncThunk('itemList', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sales_items_list',
            headers: { "Content-Type": "application/json" },
            data: {

                "vmodel_no": data?.search,
                "all": "2",
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "aj": "0",
                "vitem_allowed": "1",
                "vdate": "",
                "idivision_id": '0',
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vsupplier_code": "",
                "cvendor_po_type": "",
                "iware_house_id": "0",
                "pageing": data?.pageIndex.toString(),
                "vparent_group_code": "",
                "vgroup_code": "",
                "ccategeory": data?.category,
                "itype": "1",
                // "page": data && data.pageIndex,
                "ilimit": '500'

            }
        })
        return itemListRes = res.data

    } catch (error) {
        return itemListRes = error.response.data
    }
});

const itemListSlice = createSlice({
    name: 'itemList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(itemListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(itemListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default itemListSlice.reducer; 